import {
    SET_AREA_FACET,
    SET_AREA_FACET_VALUE,
    SET_AREA_GEOJSON,
    SET_AREA_CRITERIA_ADVANCED_MODE,
    SET_AREA_CRITERIA,
    SET_AREA_LAYER,
    SET_FORM_PROPERTIES,
    CLEAR_AREA
} from './Types';

import axios from 'axios';
import { debounce } from 'lodash';
import { MAIN_MAP } from '../map/Constants';
import { setFitBoundsFromGeojson } from '../map/Actions';
import { Criteria, Geojson } from '../../utility/Types/commonTypes';
import {
    COMPARABLE_REDUCER,
    PLANNING_REDUCER,
    SEARCH_REDUCER,
    OWNERSHIP_REDUCER
} from '../ReducerNames';
import CleanCriteria from './CleanCriteria';

export const setFormProperties = (reducerName: string, props: any) => {
    return { type: SET_FORM_PROPERTIES, reducerName, props };
};

export const clearArea = (reducerName: string) => {
    return { type: CLEAR_AREA, reducerName };
};

export const setAreaFacet = (reducerName: string, facetId: number) => {
    return { type: SET_AREA_FACET, reducerName, facetId };
};

export const setAreaFacetValue = (reducerName: string, value: number) => {
    return { type: SET_AREA_FACET_VALUE, reducerName, value };
};

export const setAreaGeojson = (reducerName: string, geojson: Geojson) => {
    return { type: SET_AREA_GEOJSON, reducerName, geojson };
};

export const setAreaCriteriaAdvancedMode = (
    reducerName: string,
    isAdvanced: boolean
) => {
    return (dispatch: (dispatch: any) => Promise<void>, getState: () => any) => {
        // When changing advanced mode, pass through the default criteria in case we need to reset back to it
        const searchLayers = getState().layers.searchLayers;
        // TODO - Remove hard coded search area which should be search area key, currently fine since only search area uses advanced mode
        // This should be the only area where this needs changing currently
        const layerId = getState()[reducerName].searchArea.layerId;
        let criteria = getState()[reducerName].searchArea.criteria;
        const layer = searchLayers
            ? (Object.values(searchLayers).find(
                  (el: { id: number }) => el.id === layerId
              ) as { defaultTree: any; subfields: any })
            : null;
        if (!isAdvanced) {
            criteria = CleanCriteria(criteria, layer?.subfields, 'simple_search');
        }
        dispatch({
            type: SET_AREA_CRITERIA_ADVANCED_MODE,
            reducerName,
            isAdvanced,
            criteria
        });
    };
};

export const setAreaCriteria = (reducerName: string, criteria: Criteria) => {
    return { type: SET_AREA_CRITERIA, reducerName, criteria };
};

const featureMap = {
    [SEARCH_REDUCER]: 'siteFinder',
    [PLANNING_REDUCER]: 'planningAlerts',
    [COMPARABLE_REDUCER]: 'comparable',
    [OWNERSHIP_REDUCER]: 'ownershipReducer'
};

type ReducerNameType =
    | 'search'
    | 'planningReducer'
    | 'comparableReducer'
    | 'ownershipReducer';

export const setAreaLayer = (reducerName: ReducerNameType, id: number) => {
    return (dispatch: (dispatch: any) => Promise<void>, getState: () => any) => {
        const searchLayers = getState().layers.searchLayers;

        const feature = featureMap[reducerName];
        const searchFeatures = getState().user.features[feature];
        const searchLayerFeature =
            searchFeatures?.layers.find(
                (l: { layerId: number }) => l.layerId === id
            ) || searchFeatures;
        const isCriteriaAdvancedMode =
            searchLayerFeature?.advancedCriteriaEnabled &&
            searchLayerFeature.advancedCriteriaDefault;

        const layer = searchLayers
            ? (Object.values(searchLayers).find(
                  (el: { id: number }) => el.id === id
              ) as { defaultTree: any; subfields: any })
            : null;
        let criteria = layer?.defaultTree || {
            id: 'root',
            type: 'group',
            conjunction: 'and',
            not: false,
            children: []
        };
        criteria = isCriteriaAdvancedMode
            ? criteria
            : CleanCriteria(criteria, layer?.subfields, 'simple_search');
        dispatch({
            type: SET_AREA_LAYER,
            reducerName,
            layerId: id,
            criteria,
            isCriteriaAdvancedMode
        });
    };
};

const validateAreaFacetValue = (
    dispatch: (
        arg0:
            | { type: string; reducerName: string; geojson: Geojson }
            | { type: string; name: string; bounds: number[]; options: {} }
    ) => void,
    reducerName: string,
    facetId: string | number,
    value: any
) => {
    return axios
        .get(`/api/facets/${facetId}/validate?value=${value}`)
        .then(response => {
            dispatch(
                setAreaGeojson(
                    reducerName,
                    response.data.valid ? response.data.geometry : null
                )
            );
            if (response.data.valid) {
                dispatch(
                    setFitBoundsFromGeojson(
                        response.data.bounds,
                        { maxZoom: 16 },
                        MAIN_MAP
                    )
                );
            }
        })
        .catch(error => {
            if (axios.isCancel(error)) {
                console.log('cancel');
            } else {
                console.error(error);
            }
        });
};
const debouncedValidateAreaFacetValue = debounce(validateAreaFacetValue, 500);
export const validateAreaFacetValueAsync = (
    reducerName: string,
    facetId: any,
    value: any
) => {
    return (
        dispatch: (arg0: {
            type: string;
            reducerName: string;
            geojson: Geojson;
        }) => void
    ) => {
        debouncedValidateAreaFacetValue(dispatch, reducerName, facetId, value);
    };
};
